import React, { useContext } from "react";
import { Form as FinalForm } from "react-final-form";
import {
  Container,
  Form,
  Label,
  Button,
} from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../../app/stores/rootStore";
import { getTestSetStatusOptions } from "../../../app/util/GeneralEnumsOptions";
import { documentsConfigurations } from "./constants";

const SendDocumentToProd = ({ activeDocumentState,  activeDocument, isDisabled }) => {
  const isActiveDocumentProdEnabled = activeDocumentState?.status === 8 && activeDocumentState?.sendState !== 0;
  const rootStore = useContext(RootStoreContext);
  const {
    loadingSendProdTestSetDocument,
    sendProdTestSetDocument,
  } = rootStore.companyStore;

  const handleSendProdTestSetDocument = () => {
    sendProdTestSetDocument(documentsConfigurations?.[activeDocument]?.id);
  };

  return (
    <div>
      <FinalForm
        onSubmit={handleSendProdTestSetDocument}
        render={({ handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <Container textAlign="justified">
              <p className={`${isDisabled ? "text-disabled" : ""}`}>
                El envío del set de pruebas ha finalizado. Ingresa con el token a la Dian y deja al cliente en modo productivo.
              </p>
              <Button
                className="ui primary button"
                color="blue"
                type="submit"
                icon="send"
                content="Pasar a modo productivo en Majim-e"
                disabled={isDisabled || isActiveDocumentProdEnabled || loadingSendProdTestSetDocument}
                loading={loadingSendProdTestSetDocument}
              />
              {activeDocumentState.status === 8 && (
                <Label
                  className="set-test-prod-label"
                  basic
                  color="green"
                >
                  {getTestSetStatusOptions(activeDocumentState?.status)}
                </Label>
              )}
            </Container>
          </Form>
        )}
      />
    </div>
  );
};

export default observer(SendDocumentToProd);
